export default __webpack_public_path__ + "static/media/diceroll.3d71d270.PNG";